import { createContext, useContext } from 'react'
import { APP_CONTEXT_INITIAL_STATE, type AppContextType } from './app-constants'

export const AppContext = createContext<AppContextType>({
  ...APP_CONTEXT_INITIAL_STATE,
})

export const useApp = () => useContext(AppContext)
